import React from "react";
import { useTranslation } from "@ca-dmv-radv/translation";

export default function SignatureExample() {
  const { t } = useTranslation();
  const doImageLink = `${process.env.REACT_APP_IMAGE_PATHS}/img/photos/Do.png`;
  const dontImageLink = `${process.env.REACT_APP_IMAGE_PATHS}/img/photos/Dont.png`;

  return (
    <div className="flex flex--align-center flex--justify-start flex--nowrap p-8 mb-16">
      <div className="width--50-percent">
        <div className="mb-8 text--xmd text--700 text--green">
          {t("nch-signature-upload-do", "DO")}
        </div>
        <img src={doImageLink} alt="Example of a good signature upload" />
      </div>
      <div className="width--50-percent pl-30">
        <div className="mb-8 text--xmd text--700 text--red">
          {t("nch-signature-upload-dont", "DON'T")}
        </div>
        <img src={dontImageLink} alt="Example of a bad signature upload" />
      </div>
    </div>
  );
}
